import {
  ClockIcon,
  MapPinIcon,
  UsersIcon,
  XMarkIcon,
} from "@heroicons/react/24/outline";
import { formatDistanceToNowStrict } from "date-fns";
import React, { useEffect } from "react";
import JobLink from "../../components/JobLink";
import { trackCustomEvent } from "../../utils/analytics";

export default function ModalJobSuggestion({
  tx,
  cpaModalTx,
  hostedApplyTx,
  data,
  toggleModalState,
  location,
}) {
  useEffect(() => {
    trackCustomEvent({
      category: "SERP",
      action: `Modal load: job`,
      label: location.pathname,
    });
  }, [location.pathname]);

  const job = data && data[0];

  if (!job)
    return (
      <div className="flex flex-col items-center justify-center p-20">
        <button
          data-cy="modal-loading-close"
          className="absolute right-6 top-6 rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
          onClick={(event) => {
            toggleModalState(null);
            event.preventDefault();
            event.stopPropagation();
          }}
        >
          <span className="sr-only">Close</span>
          <XMarkIcon className="h-6 w-6" aria-hidden="true" />
        </button>
        <div className="loader relative h-20 w-20" />
      </div>
    );

  const { city, company, title, summary, date } = job;
  return (
    <JobLink
      gaCategory="SERP"
      cpaModalTx={cpaModalTx}
      hostedApplyTx={hostedApplyTx}
      job={job}
      className="group block p-5"
      onClick={() => {
        toggleModalState(null);
        trackCustomEvent({
          category: "SERP",
          action: `Job click`,
          label: `${location.pathname} job modal`,
        });
      }}
    >
      <div className="flex items-start justify-between">
        <h3 className="text-md mb-4 flex items-baseline text-2xl font-extrabold capitalize tracking-tight text-primary-600">
          {title}
        </h3>
        <button
          data-cy="modal-close"
          className="rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
          onClick={(event) => {
            toggleModalState(null);
            event.preventDefault();
            event.stopPropagation();
          }}
        >
          <span className="sr-only">Close</span>
          <XMarkIcon className="h-6 w-6" aria-hidden="true" />
        </button>
      </div>
      {company && (
        <p className="mt-4 flex items-center text-sm text-gray-500 sm:mt-4">
          <UsersIcon
            className="mr-1.5 h-5 w-5 flex-shrink-0 "
            aria-hidden="true"
          />
          {company}
        </p>
      )}
      {city && city !== "null" && (
        <p className="mt-4 flex items-center text-sm text-gray-500 sm:mt-4">
          <MapPinIcon
            className="mr-1.5 h-5 w-5 flex-shrink-0"
            aria-hidden="true"
          />
          {city}
        </p>
      )}
      {date && (
        <p className="mt-4 flex items-center text-sm text-gray-500">
          <ClockIcon className="mr-1.5 h-5 w-5" />
          {tx!.postedXago.replace(
            "{{time}}",
            formatDistanceToNowStrict(new Date(date))
          )}
        </p>
      )}
      <div
        className="multiline-truncate mt-4 block overflow-hidden text-sm text-gray-500"
        dangerouslySetInnerHTML={{
          __html: summary,
        }}
      />
      <button
        className="mt-8 flex w-full flex-shrink-0 items-center justify-center rounded-md border border-transparent bg-primary-600 px-5 py-3 text-base font-medium text-white hover:bg-primary-700"
        tabIndex={-1}
      >
        {tx!.viewJob}
      </button>
    </JobLink>
  );
}
